import { ErrorCode } from '@enums/error-codes.enum';

/**
 * The API returns `errorCode` as a top-level field on the GraphQL error object
 * (a sibling of `message`), not inside `extensions`. Apollo wraps those errors
 * in an ApolloError, so the code has to be looked up in both places.
 */
export function hasErrorCode(error: any, code: ErrorCode): boolean {
  if (error?.errorCode === code) {
    return true;
  }
  return !!error?.graphQLErrors?.some((graphQLError: any) => graphQLError?.errorCode === code);
}
